// src/components/MuvingAnimation.js
import React from 'react';
import './MuvingAnimation.css'; // Creeremo questo file CSS

// Supponiamo che il tuo sprite sheet si chiami 'ciclista_sprite.png' e sia nella cartella public/images
// Se lo metti in src/assets, dovrai importarlo:
// import ciclistaSprite from '../assets/ciclista_sprite.png';

function MuvingAnimation({ text = "Muving" }) {
  return (
    <div className="muving-container">
      <div
        className="ciclista-sprite"
        // Se importato: style={{ backgroundImage: `url(${ciclistaSprite})` }}
        // Se in public: style={{ backgroundImage: `url(/images/ciclista_sprite.png)` }}
      >
      </div>
      <span className="muving-text">{text}...</span>
    </div>
  );
}

export default MuvingAnimation;